import { createSelector } from "reselect";

// TODO: Replace with actual policy or other permission schema
export const monitoringTabEnabledSelector = createSelector(() => false);
